import { Ability, AbilityCan, AbilitySubject } from "@cdv/jazz-auth";
import { CurrentUser, Resource } from "../api";
import User from "./ability/User";
import Company from "./ability/Company";
import CompanyUser from "./ability/CompanyUser";
import Score from "./ability/Score";
import Page from "./ability/Page";
import Audio from "./ability/Audio";
import Image from "./ability/Image";
import TestDefinition from "./ability/TestDefinition";
import TestVersion from "./ability/TestVersion";

const subjects: { [k in Resource]?: (can: AbilitySubject<CurrentUser>) => void } = {
  User,
  Company,
  CompanyUser,
  Page,
  Score,
  Audio,
  Image,
  TestDefinition,
  TestVersion,
};

const ability = new Ability<CurrentUser>();

Object.entries(subjects).forEach(([subject, define]) => define(ability.for(subject)));

export const can: AbilityCan<CurrentUser> = ability.build();
